import { render, staticRenderFns } from "./ai-protocol-nav.vue?vue&type=template&id=16186992&scoped=true"
import script from "./ai-protocol-nav.vue?vue&type=script&lang=js"
export * from "./ai-protocol-nav.vue?vue&type=script&lang=js"
import style0 from "./ai-protocol-nav.vue?vue&type=style&index=0&id=16186992&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16186992",
  null
  
)

export default component.exports